import { updateDriverPerformanceMainItem, updateDriverPerformanceOverviewItem } from '../../../../../.globals/redux/actions'

export class DRIVERPERFORMANCE {
    execute = (payload, state, dispatch) => {
        if (!payload || !state) return;

        const { entities = [], key, status } = payload;

        const {
            driverPerformanceEventsTabRedux: { events: mainEvents = [] } = {},
            driverPerformanceRiskTabRedux: { events: riskEvents = []}
        } = state;

        if (key === "UPDATE" && entities && entities.length > 0) {
            for (const updatedEvent of entities) {
                // Check if event exists in main events
                let existsInMain = mainEvents.some(event => event.esn == updatedEvent.unitId && event?.rowId == updatedEvent.rowId);
                if (existsInMain) {
                    let index = mainEvents.findIndex(event => event.esn == updatedEvent.unitId && event?.rowId == updatedEvent.rowId);
                    dispatch(updateDriverPerformanceMainItem({ key: index, status }));
                }

                // Check if event exists in risk events (nested structure)
                let existsInRisk = false;
                if (riskEvents && riskEvents.length > 0) {
                    existsInRisk = riskEvents.some(category => 
                        category.events && category.events.some(event => 
                            event.unitId == updatedEvent.unitId && event.rowId == updatedEvent.rowId
                        )
                    );
                }
                
                if (existsInRisk) {
                    dispatch(updateDriverPerformanceOverviewItem({ 
                        unitId: updatedEvent.unitId, 
                        rowId: updatedEvent.rowId, 
                        status 
                    }));
                }
            }
        }
    };
}

